import VariantCharacterGroupService from "@/services/variantCharacterGroup.service.js";

export default class VariantCharacterGroupUsecase {
  constructor () {
    this.VariantCharacterGroupService = new VariantCharacterGroupService();
  }

  async getVariantCharacterGroups (options) {
    const res = await this.VariantCharacterGroupService.list(options);
    return res;
  }

  async getVariantCharacterGroup (options) {
    const res = await this.VariantCharacterGroupService.get(options);
    return res;
  }

  async createVariantCharacterGroup (options) {
    const res = await this.VariantCharacterGroupService.create(options);
    return res;
  }

  async updateVariantCharacterGroup (options) {
    const res = await this.VariantCharacterGroupService.update(options);
    return res;
  }

  async deleteVariantCharacterGroup (options) {
    const res = await this.VariantCharacterGroupService.delete(options);
    return res;
  }
}
